import { sendRequest } from "../request";
const BASE_URL = '/api/services';


export function getServices() {
    return sendRequest(`${BASE_URL}`);
}
